import { AlertStyled } from 'components/alert/alert.styles';
import { Text } from 'components/ui/text';
import { lighten, rem } from 'polished';
import styled from 'styled-components';

export const ToolsCardStyled = styled(AlertStyled)`
  display: flex;
  text-decoration: none;
  background-color: ${({ theme }) => theme.colors.palette.white};

  & + & {
    margin-top: ${rem(16)};
  }

  &:hover {
    background-color: ${({ theme }) =>
      lighten(0.45, theme.colors.palette.grey)};
  }

  * {
    color: ${({ theme }) => theme.colors.palette.black};
  }
`;

export const ToolsCardStyledNoHover = styled(ToolsCardStyled)`
  pointer-events: none;
`;

export const CardText = styled(Text)`
  margin-top: ${rem(4)};
  margin-bottom: 0;
  font-style: italic;
`;

export const IconAlertWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: center;
  width: 40px;

  svg {
    width: 100%;
  }
`;
